import { Link } from 'react-router-dom';

const ErrorPage = () => {
  return (
    <div className="error-page" style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred or the page was not found.</p>
      <Link to="/" style={{ color: '#15A5B5', textDecoration: 'underline' }}>Go back to home</Link>
    </div>
  );
};

export default ErrorPage;
